export default "__VITE_ASSET__SLV2uZC2__"